import React, { useState } from 'react';

const SubscribeBar = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [modalMsg, setModalMsg] = useState('');
  const [error, setError] = useState('');

  // Get CSRF token from cookie
  const getCsrfToken = () => {
    const name = 'csrftoken';
    let cookieValue = null;
    
    if (document.cookie && document.cookie !== '') {
      const cookies = document.cookie.split(';');
      for (let i = 0; i < cookies.length; i++) {
        const cookie = cookies[i].trim();
        if (cookie.substring(0, name.length + 1) === (name + '=')) {
          cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
          break;
        }
      }
    }
    return cookieValue;
  };

  const handleSubscribe = async () => {
    // Basic validation
    if (!email || !email.includes('@')) {
      setError('Please enter a valid email address.');
      return;
    }
    
    setError('');
    setLoading(true);
    
    try {
      const csrfToken = getCsrfToken();
      console.log('CSRF Token:', csrfToken ? 'Found' : 'Not found');
      console.log('Subscribing email:', email);
      
      const res = await fetch('/internal/subscribe/', {
        method: 'POST',
        headers: { 
          'Content-Type': 'application/json',
          'X-CSRFToken': csrfToken || '',
        },
        credentials: 'include',
        body: JSON.stringify({ email: email.trim().toLowerCase() }),
      });
      
      console.log('Response status:', res.status);
      
      const data = await res.json();
      console.log('Response data:', data);
      
      if (res.ok || res.status === 201 || res.status === 200) {
        setModalMsg(data.message || 'Thank you for subscribing!');
        setShowModal(true);
        setEmail('');
      } else if (res.status === 400) {
        if (data.email) {
          setError(Array.isArray(data.email) ? data.email[0] : data.email);
        } else if (data.error) {
          setError(data.error);
        } else {
          setError('Please enter a valid email address.');
        }
      } else if (res.status === 403) {
        console.error('CSRF token issue');
        setError('Security error. Please refresh the page and try again.');
      } else {
        console.error('Unexpected status:', res.status);
        setError('Something went wrong. Please try again.');
      }
      
    } catch (err) {
      console.error('Subscribe error:', err);
      setError('Network error. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {/* Subscribe Bar */}
      <div style={s.bar} id="subscribe-section">
        <div style={s.inner}>
          <div style={s.text}>
            <span style={s.label}>🔔 Stay Informed</span>
            <span style={s.sub}>Get the latest defense news delivered to your inbox</span>
          </div>
          <div style={s.form}>
            <input
              type="email"
              placeholder="Enter your email address"
              value={email}
              onChange={e => setEmail(e.target.value)}
              onKeyDown={e => e.key === 'Enter' && handleSubscribe()}
              style={s.input}
              disabled={loading}
            />
            <button
              onClick={handleSubscribe}
              disabled={loading}
              style={{ 
                ...s.btn, 
                opacity: loading ? 0.7 : 1,
                cursor: loading ? 'not-allowed' : 'pointer'
              }}
            >
              {loading ? 'Subscribing…' : 'Subscribe'}
            </button>
          </div>
          {error && <p style={s.error}>{error}</p>}
        </div>
      </div>

      {/* Success Modal */}
      {showModal && (
        <div style={s.overlay} onClick={() => setShowModal(false)}>
          <div style={s.modal} onClick={e => e.stopPropagation()}>
            <div style={s.modalIcon}>🎉</div>
            <h2 style={s.modalTitle}>Congratulations!</h2>
            <p style={s.modalMsg}>{modalMsg}</p>
            <p style={s.modalThanks}>
              Thank you for subscribing to Weekly Defense.<br />
              You'll be the first to know about breaking defense news.
            </p>
            <button style={s.modalBtn} onClick={() => setShowModal(false)}>
              Got it!
            </button>
          </div>
        </div>
      )}
    </>
  );
};

const s = {
  bar: {
    background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 100%)',
    borderTop: '1px solid rgba(59,130,246,0.25)',
    borderBottom: '1px solid rgba(59,130,246,0.25)',
    padding: '1.5rem 2rem',
  },
  inner: {
    maxWidth: 1200, 
    margin: '0 auto',
    display: 'flex', 
    alignItems: 'center',
    gap: '2rem', 
    flexWrap: 'wrap',
  },
  text: {
    display: 'flex', 
    flexDirection: 'column', 
    gap: 4, 
    flex: '1 1 200px',
  },
  label: {
    color: '#f1f5f9', 
    fontSize: '1.05rem', 
    fontWeight: 700,
  },
  sub: {
    color: '#94a3b8', 
    fontSize: '0.85rem',
  },
  form: {
    display: 'flex', 
    gap: '0.75rem', 
    flex: '2 1 380px',
  },
  input: {
    flex: 1, 
    padding: '0.75rem 1rem',
    background: 'rgba(255,255,255,0.07)',
    border: '1px solid rgba(255,255,255,0.15)',
    borderRadius: 8, 
    color: '#f1f5f9',
    fontSize: '0.95rem', 
    outline: 'none',
    transition: 'border-color 0.2s',
  },
  btn: {
    padding: '0.75rem 1.5rem',
    background: 'linear-gradient(135deg, #1d4ed8, #1e40af)',
    color: '#fff', 
    border: 'none', 
    borderRadius: 8,
    fontWeight: 700, 
    fontSize: '0.95rem', 
    cursor: 'pointer',
    whiteSpace: 'nowrap',
    transition: 'all 0.2s',
  },
  error: { 
    color: '#f87171', 
    fontSize: '0.85rem', 
    margin: '0.5rem 0 0', 
    width: '100%',
    padding: '0.5rem',
    background: 'rgba(248, 113, 113, 0.1)',
    borderRadius: 4,
  },
  // Modal styles
  overlay: {
    position: 'fixed', 
    inset: 0, 
    zIndex: 1000,
    background: 'rgba(0,0,0,0.75)', 
    backdropFilter: 'blur(4px)',
    display: 'flex', 
    alignItems: 'center', 
    justifyContent: 'center',
  },
  modal: {
    background: 'linear-gradient(160deg, #1e293b, #0f172a)',
    border: '1px solid rgba(59,130,246,0.3)',
    borderRadius: 20, 
    padding: '2.5rem',
    maxWidth: 420, 
    width: '90%', 
    textAlign: 'center',
    boxShadow: '0 25px 60px rgba(0,0,0,0.6)',
  },
  modalIcon: { 
    fontSize: '3rem', 
    marginBottom: '0.75rem' 
  },
  modalTitle: { 
    color: '#f1f5f9', 
    fontSize: '1.6rem', 
    fontWeight: 800, 
    margin: '0 0 0.75rem' 
  },
  modalMsg: { 
    color: '#60a5fa', 
    fontSize: '1rem', 
    fontWeight: 600, 
    margin: '0 0 0.5rem' 
  },
  modalThanks: { 
    color: '#94a3b8', 
    fontSize: '0.875rem', 
    lineHeight: 1.6, 
    margin: '0 0 1.5rem' 
  },
  modalBtn: {
    padding: '0.75rem 2rem',
    background: 'linear-gradient(135deg, #1d4ed8, #1e40af)',
    color: '#fff', 
    border: 'none', 
    borderRadius: 10,
    fontWeight: 700, 
    fontSize: '0.95rem', 
    cursor: 'pointer',
    transition: 'all 0.2s',
  },
};

export default SubscribeBar;